import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    close: {
        id: "general.close",
    }
});

export default messages;
